import { trackElementInteraction } from './util/analytics'

up.on('up:link:follow', (event) => {
  let link = event.target
  let href = link.getAttribute('href')
  trackElementInteraction(link, 'click.link', { link: { href } })
})

up.on('click', 'a', (event) => {
  let link = event.currentTarget
  let href = link.href

  let currentHost = window.location.host
  let targetHost = link.host

  if (targetHost !== '' && targetHost !== currentHost) {
    trackElementInteraction(link, 'externalLink.click', { link: { href } })
  }
})
